import paneresize from "../../../../assets/videos/pane-resize.mp4";
import * as React from 'react';
export default {
  paneresize,
  React
};